import { Pipe, PipeTransform } from "@angular/core";
import { MetricFormat, getFormattedMetricValue } from "@webapp/okrs/utils/metric-value.utils";

@Pipe({ name: "metricValue" })
export class MetricValuePipe implements PipeTransform {
  public transform(value: number, format: MetricFormat, options: { maxFractionSize?: number; withoutRounding?: boolean; withThousandsSeparator?: boolean } = {}): string {
    return getFormattedMetricValue(value, format, options);
  }
}
